import styled from 'styled-components';

import { TextInputMasked } from 'components/modules/Insurance/Insurance.styles';

import { NAME, PRICE_MASK } from './PriceInput.constants';

export const PriceInput = styled(TextInputMasked).attrs({
  label: 'Стоимость',
  mask: PRICE_MASK,
  name: NAME,
})``;
